export const SUMMARY_MESSAGE = 'summaryMessage';
export const DETAIL_MESSAGE = 'detailMessage';
